import { render, staticRenderFns } from "./MyLabelTrueFalse.vue?vue&type=template&id=6b7dd12e&scoped=true&"
import script from "./MyLabelTrueFalse.vue?vue&type=script&lang=js&"
export * from "./MyLabelTrueFalse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7dd12e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7dd12e')) {
      api.createRecord('6b7dd12e', component.options)
    } else {
      api.reload('6b7dd12e', component.options)
    }
    module.hot.accept("./MyLabelTrueFalse.vue?vue&type=template&id=6b7dd12e&scoped=true&", function () {
      api.rerender('6b7dd12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyLabelTrueFalse.vue"
export default component.exports